import Vue from "vue";
import VueRouter from "vue-router";
import GameView from "@/views/MoreGame/index";
import gameDetails from "./gameDetails";
import ecardShop from "./ecardShop";
import fullscreen from 'vue-fullscreen';

//解决重复点击报错*2
const originPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  // console.log(this.history.current)
  // console.log(location)
  let history = this.history.current.name
  if (location.name === history) {
    window.location.reload();
  }
  return originPush.call(this, location).catch(() => {});
};
Vue.use(VueRouter);
Vue.use(fullscreen);

const routes = [
  {
    path: "/",
    redirect: "/moreGame",
  },
  {
    path: "/moreGame",
    name: "moreGame",
    redirect: "/moreGame/recommend",
    meta: {page:"moreGame"},
    component: GameView,
    children: [
      {
        path: "recommend",
        name: "recommend",
        meta: {page:"moreGame"},
        component: () => import("@/views/MoreGame/Recommend"),
      },
      {
        path: "h5",
        name: "h5",
        meta: {page:"moreGame"},
        component: () => import("@/views/MoreGame/H5"),
      },
      {
        path: "handtour",
        name: "handtour",
        meta: {page:"moreGame"},
        component: () => import("@/views/MoreGame/HandTour"),
      },
      {
        path: "wActivity",
        name: "wActivity",
        meta: {page:"moreGame"},
        component: () => import("@/views/MoreGame/WActivity"),
      },
      {
        path: "rankList",
        name: "rankList",
        meta: {page:"moreGame"},
        component: () => import("@/views/MoreGame/RankList"),
      },
    ],
  },
  {
    path: "/taskCenter",
    name: "taskCenter",
    meta: {page:"moreGame"},
    component: () => import("@/views/TaskCenter"),
  },
  {
    path: "/taskCenterDetail/:id",
    name: "taskCenterDetail",
    meta: {page:"moreGame"},
    component: () => import("@/views/TaskCenter/TaskCenterDetail.vue"),
  },
  {
    path: "/newPersonTask",
    name: "newPersonTask",
    meta: {page:"moreGame"},
    component: () => import("@/views/NewPersonTask"),
  },
  {
    path: "/activityDetail/:id",
    name: "activityDetail",
    meta: {page:"moreGame"},
    component: () => import("@/views/HotActivity/ActivityDetail.vue"),
  },
  {
    path: "/hotActivity",
    name: "hotActivity",
    meta: {page:"moreGame"},
    component: () => import("@/views/HotActivity"),
  },
  {
    path: "/signIn",
    name: "signIn",
    meta: {page:"moreGame"},
    component: () => import("@/views/SignIn"),
  },
  {
    path: "/message",
    name: "message",
    meta: {page:"moreGame"},
    component: () => import("@/views/Message"),
  },
  {
    path: "/messageDetail/:id",
    name: "messageDetail",
    meta: {page:"moreGame"},
    component: () => import("@/views/Message/MessageDetail.vue"),
  },
  {
    path: "/search",
    name: "search",
    meta: {page:"moreGame"},
    component: () => import("@/views/Search"),
  },
  {
    path: "/game/:gameUrl?",
    name: "game",
    meta: {page:"moreGame"},
    component: () => import("@/views/Game"),
  },
  {
    path: "/anchorZone",
    name: "anchorZone",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone"),
  },
  {
    path: "/taskDetail",
    name: "taskDetail",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/TaskDetail"),
  },
  {
    path: "/anchorDetail",
    name: "anchorDetail",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/AnchorDetail"),
  },
  {
    path: "/recommendation",
    name: "recommendation",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/Recommendation"),
  },
  {
    path: "/anchorTaskList",
    name: "anchorTaskList",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/AnchorTaskList"),
  },
  {
    path: "/attendLog",
    name: "attendLog",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/AttendLog"),
  },
  {
    path: "/income",
    name: "income",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/Income"),
  },
  {
    path: "/cashOut",
    name: "cashOut",
    meta: {page:"anchorZone"},
    component: () => import("@/views/AnchorZone/pages/CashOut"),
  },
  {
    path: "/userCenter",
    name: "userCenter",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter"),
  },
  {
    path: "/userInfo/:updated?",
    name: "userInfo",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/UserInfo"),
  },
  {
    path: "/deleteAcount",
    name: "deleteAcount",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/DeleteAcount"),
  },
  {
    path: "/bindPhone",
    name: "bindPhone",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/BindPhone"),
  },
  {
    path: "/bindNewUserPhone",
    name: "bindNewUserPhone",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/BindNewUserPhone"),
  },
  {
    path: "/settings",
    name: "settings",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/Settings"),
  },
  {
    path: "/help",
    name: "help",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/Help"),
  },
  {
    path: "/feedBack",
    name: "feedBack",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/FeedBack"),
  },
  {
    path: "/membership",
    name: "membership",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/Membership"),
  },
  {
    path: "/myGame",
    name: "myGame",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/MyGame"),
  },
  {
    path: "/coinDetail",
    name: "coinDetail",
    meta: {page:"userCenter"},
    component: () => import("@/views/UserCenter/pages/CoinDetail"),
  },
  {
    path: "/giftBag",
    name: "giftBag",
    meta: {page:"userCenter"},
    component: () => import("@/views/GiftBag"),
  },
  {
    path: "/myGiftLog",
    name: "myGiftLog",
    meta: {page:"userCenter"},
    component: () => import("@/views/GiftBag/pages/MyGiftLog"),
  },
  {
    path: "/applyVipGift",
    name: "applyVipGift",
    meta: {page:"userCenter"},
    component: () => import("@/views/GiftBag/pages/ApplyVipGift"),
  },
  {
    path: "/activities",
    name: "activities",
    meta: {page:"userCenter"},
    component: () => import("@/views/Activities"),
  },
  {
    path: "/historyActivity",
    name: "historyActivity",
    meta: {page:"userCenter"},
    component: () => import("@/views/HistoryActivity"),
  },
  {
    path: "/activiteDetail/:id/:type",
    name: "activiteDetail",
    meta: {page:"userCenter"},
    component: () => import("@/views/Activities/pages/ActiviteDetail"),
  },
  {
    path: "/voucherCenter",
    name: "voucherCenter",
    meta: {page:"userCenter"},
    component: () => import("@/views/VoucherCenter"),
  },
  {
    path: "/myVoucher",
    name: "myVoucher",
    meta: {page:"userCenter"},
    component: () => import("@/views/VoucherCenter/pages/MyVoucher"),
  },
  {
    path: "/historyRank",
    name: "historyRank",
    meta: {page:"moreGame",keepAlive:true},
    component: () => import("@/views/HistoryRank"),
  },
  ...gameDetails,
  ...ecardShop,
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});



export default router;
